export const ERROR_CODE = {
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  NO_ORGANIZATION_ACCESS: 'NO_ORGANIZATION_ACCESS',
  PERSONAL_EMAIL_NOT_ALLOWED: 'PERSONAL_EMAIL_NOT_ALLOWED',
  PERSONAL_EMAIL_LOGIN_DENIED: 'PERSONAL_EMAIL_LOGIN_DENIED',
  AAL2_REQUIRED: 'AAL2_REQUIRED',
  MFA_REAUTH_REQUIRED: 'MFA_REAUTH_REQUIRED',
  ACCESS_CONTROL_DENIED: 'ACCESS_CONTROL_DENIED',
  PERMISSION_AND_ROLE_DENIED: 'PERMISSION_AND_ROLE_DENIED',
} as const;

export type ErrorCode = (typeof ERROR_CODE)[keyof typeof ERROR_CODE];
